module.exports = __webpack_public_path__ + "static/media/linkedin.8f4b53b7.svg";